import 'preline/preline'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'aos/dist/aos.css'
import 'glightbox/dist/css/glightbox.min.css'
import '@/assets/css/icons.css'
import '@/assets/css/style.css'
import AOS from 'aos'
import log from "loglevel";
import {createApp} from 'vue'
import {createPinia} from 'pinia'
//import { registerSW } from 'virtual:pwa-register'
import App from './App.vue'
import router from './router'
import setupInterceptors from "./setup/setup-interceptors";

AOS.init()

globalThis.log = log;
log.setDefaultLevel("trace")

//registerSW({ immediate: true })
const app = createApp(App)

app.use(createPinia())
app.use(router)


// Setup Axios interceptors
setupInterceptors(router);

//log.setLevel()
log.info("AnyMic is starting up...");


// 🔥 Fetch the user before the app starts
app.mount('#app')

